import { SECTIONS } from "@/components/assessment/assessmentData";

const stateSection = SECTIONS.find((section) => section.id === "state");
const capacitySection = SECTIONS.find((section) => section.id === "capacity");

if (stateSection) {
  stateSection.label = "01 · Regulation & Flexibility";
  stateSection.heading = "How does your nervous system usually respond and transition?";
  stateSection.dimensionLabel = "Regulatory Flexibility";
  stateSection.items = [
    {
      key: "usableEnergyReliability",
      q: "How reliably do you have usable physical energy when you need it?",
      scaleLow: "1 · Rarely available",
      scaleHigh: "5 · Reliably available",
    },
    {
      key: "mobilizationFit",
      q: "When a situation calls for action, how well can your system mobilize without overshooting or shutting down?",
      scaleLow: "1 · Often mismatched",
      scaleHigh: "5 · Usually well matched",
    },
    {
      key: "behavioralChoice",
      q: "When emotion or pressure is strong, how much choice do you usually retain over what you do next?",
      scaleLow: "1 · Very little choice",
      scaleHigh: "5 · Strong choice",
    },
    {
      key: "cognitiveFlexibility",
      q: "When something strongly captures your attention, how easily can you shift focus when you need to?",
      scaleLow: "1 · Very difficult",
      scaleHigh: "5 · Usually flexible",
    },
    {
      key: "transitionFlexibility",
      q: "When a demand is over, how well can you move from high activation toward a working or recovery state?",
      scaleLow: "1 · Usually difficult",
      scaleHigh: "5 · Usually transitions well",
    },
    {
      key: "recoveryEfficiency",
      q: "After a demanding physical or emotional period, how reliably do you recover enough to function normally again?",
      scaleLow: "1 · Recovery is difficult",
      scaleHigh: "5 · Recovery is reliable",
    },
    {
      key: "bodySignalClarity",
      q: "How clearly do you notice body signals such as tension, breathing changes, restlessness, heaviness, or fatigue before they strongly affect what you do?",
      scaleLow: "1 · Usually notice late",
      scaleHigh: "5 · Usually notice early",
    },
    {
      key: "sleepRestoration",
      q: "How restorative does your sleep usually feel?",
      scaleLow: "1 · Not restorative",
      scaleHigh: "5 · Very restorative",
    },
  ];
}

if (capacitySection) {
  capacitySection.label = "03 · Relative Physical Capacity";
  capacitySection.heading = "What can your body competently and recoverably do?";
  capacitySection.dimensionLabel = "Relative Physical Capacity";
  capacitySection.items = [
    {
      key: "activity",
      q: "How well does your current activity level support the physical demands of your life and goals?",
      scaleLow: "1 · Not well",
      scaleHigh: "5 · Very well",
    },
    {
      key: "injury",
      q: "How free are you from pain, injury, or movement limitations during familiar activity?",
      scaleLow: "1 · Very limited",
      scaleHigh: "5 · Fully unrestricted",
    },
    {
      key: "confidence",
      q: "How confident are you controlling, slowing, or stopping familiar movement when you need to?",
      scaleLow: "1 · Low control",
      scaleHigh: "5 · Strong control",
    },
    {
      key: "tolerance",
      q: "How well do you usually tolerate and recover from your current exercise or sport volume?",
      scaleLow: "1 · Poorly",
      scaleHigh: "5 · Very well",
    },
    {
      key: "familiarity",
      q: "How familiar and technically comfortable are you with the activities you currently perform?",
      scaleLow: "1 · Mostly unfamiliar",
      scaleHigh: "5 · Highly familiar",
    },
    {
      key: "recentLoad",
      q: "How manageable has your recent physical training, work, and activity load felt?",
      scaleLow: "1 · Often exceeds recovery",
      scaleHigh: "5 · Usually manageable",
    },
  ];
}

export const CORE_BASELINE_SCHEMA_VERSION = 4;

export const buildFunctionalBaselineVector = (answers = {}) => ({
  usableEnergyReliability: Number(answers.state?.usableEnergyReliability) || null,
  mobilizationFit: Number(answers.state?.mobilizationFit) || null,
  behavioralChoice: Number(answers.state?.behavioralChoice) || null,
  cognitiveFlexibility: Number(answers.state?.cognitiveFlexibility) || null,
  transitionFlexibility: Number(answers.state?.transitionFlexibility) || null,
  recoveryEfficiency: Number(answers.state?.recoveryEfficiency) || null,
  bodySignalClarity: Number(answers.state?.bodySignalClarity) || null,
  sleepRestoration: Number(answers.state?.sleepRestoration) || null,
  physicalCapacity: {
    activity: Number(answers.capacity?.activity) || null,
    movementFreedom: Number(answers.capacity?.injury) || null,
    stopControl: Number(answers.capacity?.confidence) || null,
    loadTolerance: Number(answers.capacity?.tolerance) || null,
    familiarity: Number(answers.capacity?.familiarity) || null,
    recentLoadManageability: Number(answers.capacity?.recentLoad) || null,
  },
});
